import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoyaltyReservationsService {
  baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService
  ) { }

  getReservationItemList(customerId: number, acmId: number, reservationState: string) {
    return this.http.get(`${this.baseUrl}/reservation/item?customer_id=${customerId}&acm_id=${acmId}&${reservationState}=true`);
  }

  changeReservationItemStatus(reservationId: number, status: string) {
    return this.http.put(`${this.baseUrl}/reservation/item/${reservationId}/statusUpdate?finalStatus=${status}`, {});
  }

  getReservation(reservationId: number){
    return this.http.get(`${this.baseUrl}/reservation/item?reservation_id=${reservationId}`);
  }

  getCardCheckDigit(cardNo){
    return this.http.get(`${this.baseUrl}/cards/calculateCardEan?card_no=${cardNo}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-reservations.service.ts